<template>
<div class="container-sing">
    <img class="backgroundTop backgroundColor" :src="require('@/assets/backgrounds/solidcolorsing.svg')" />
    <img class="backgroundBottom" :src="require('@/assets/backgrounds/sing.png')" />
    <ChooseGameMode v-if="current_screen == 'ChooseGameMode'" @chooseGM="onGameMode" />
    <ChooseSongSing v-if="current_screen == 'ChooseSongSing'" :country="game_mode" @chooseSong="onSongSing" />
    <Score v-if="current_screen == 'Score'" :key="childKey" :phrases="phrases" @onFinish="current_screen = 'Congrats'" @backToMenu="
        current_screen = $emit('backToMenu');
        modal_open = !modal_open;" @restart="$emit('backToMenu')" @onSavingGame="save_game"/>
    <FinalModal v-if="modal_open" @returnHome="
        current_screen =  $emit('backToMenu');
        modal_open = !modal_open;
      " @closeModal="modal_open = !modal_open" @settings="
        settings_open =! settings_open;
        modal_open = !modal_open;" />
    <WaitModal v-if="waiting" />
    <ErrorModal v-if="error" @returnHome="
        current_screen = $emit('backToMenu');
        error = !error;" @closeModal="error = !error" />
    <Settings v-if="settings_open" @closeModal="settings_open = !settings_open" />
    <Instructions v-if="instructions"
    @closeModal="instructions = !instructions" />

    <div>
        <div class="home tamanhoicon" @click="modal_open = !modal_open">
            <img :src="require('@/assets/buttons/newbuttons/sing/home.svg')" />
        </div>
        <div class="help tamanhoicon" v-if="current_screen != 'Score' && current_screen != 'Congrats'" @click="instructions=!instructions">
            <img :src="require('@/assets/buttons/newbuttons/sing/exclamation.svg')" />
        </div>
        <div class="next tamanhoicon" v-if="current_screen != 'Score' && current_screen != 'Congrats'" @click="onNext">
            <img :src="require('@/assets/buttons/newbuttons/sing/forward.svg')" />
        </div>
        <div id="backpage" class="tamanhoicon" v-if="current_screen != 'Congrats' && current_screen != 'ChooseGameMode'" @click="backpage">
            <img :src="require('@/assets/buttons/newbuttons/sing/back.svg')" />
        </div>
    </div>
</div>
</template>

<script>
import ChooseGameMode from "@/components/SingingGame/ChooseGameMode.vue";
import ChooseSongSing from "@/components/SingingGame/ChooseSongSing.vue";
import Score from "@/components/SingingGame/Score.vue";
import FinalModal from "@/components/SingingGame/FinalModal.vue";
import WaitModal from "@/components/SingingGame/WaitModal.vue";
import ErrorModal from "@/components/SingingGame/ErrorModal.vue";
import Settings from "@/components/SingingGame/Settings.vue";
import Instructions from "@/components/SingingGame/Instructions.vue";


export default {
    name: "SingingGame",
    emits: ["backToMenu", "openSettings"],
    components: {
        ChooseGameMode,
        ChooseSongSing,
        Score,
        FinalModal,
        WaitModal,
        ErrorModal,
        Settings,
        Instructions
    },
    data() {
        return {
            current_screen: "ChooseGameMode",
            game_mode: 'Portugal',
            song_id: "4",
            childKey: "",
            modal_open: false,
            waiting: false,
            error: false,
            settings_open: false,
            instructions: false,
        };
    },
    props: {
        user: Object,
    },
    methods: {
        onGameMode(mode) {
            this.game_mode = mode;
        },
        onSongSing(song_id) {
            this.song_id = song_id;
        },
        onNext() {
            switch (this.current_screen) {
                case "ChooseGameMode":
                    this.current_screen = "ChooseSongSing";
                    break;
                case "ChooseSongSing":
                    this.createMusic();
                    break;
                default:
                    break;
            }
        },
        openModal() {
            this.modal_open = true;
        },
        createMusic() {
            this.waiting = true;
            fetch(process.env.VUE_APP_API_URL + "/singGame?music_id=" + this.song_id, {
                    headers: {
                        "Access-Control-Allow-Origin": "*",
                        "Access-Control-Allow-Headers": "*",
                        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                        Accept: "application/json, text/plain, *//**",
                    },
                    method: "GET"
                })
                .then((res) => {
                    return res.json();
                })
                .then((devs) => {
                    this.phrases = devs;
                    this.waiting = false;
                    this.current_screen = "Score";
                })
                .catch((error) => {
                    console.log(error);
                    this.waiting = false;
                    this.error = !this.error;
                    this.current_screen = "ChooseSongSing";
                });
        },
        test() {},
        backpage() {
            switch (this.current_screen) {
                case "ChooseSongSing":
                    this.current_screen = "ChooseGameMode";
                    break;
                case "Score":
                    this.current_screen = "ChooseSongSing";
                    break;
                default:
                    break;
            }
        },
        save_game(recorded, velocity) {
            console.log('SAVE SING GAME');

            const formData = new FormData();
            formData.append('audio_file', recorded);

            fetch(process.env.VUE_APP_API_URL + "/saveSingGame?user_id=" + this.user['id'] + '&music_id=' + this.song_id + '&velocity=' + velocity, {
                    headers: {
                        "Access-Control-Allow-Origin": "*",
                        "Access-Control-Allow-Headers": "*",
                        //"Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                        //"Content-Type": "multipart/form-data",
                        Accept: "application/json, text/plain, *//**",
                    },
                    method: "POST",
                    body: formData,
                })
                .then((res) => {
                    return res.json();
                })
                .then((devs) => {
                    console.log(devs);
                    this.$emit('backToMenu');
                })
                .catch((error) => {
                    console.log(error);
                    error = true;
                });
        },
    },
};
</script>

<style>
/*@import url("https://fonts.googleapis.com/css?family=Roboto:700");*/
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@700&display=swap");

.container-sing {
    pointer-events: none;
    display: flex;
    flex-direction: row;
    justify-content: justify;
    width: 100%;
    height: 100%;
    /* background-color:#121338; */
    z-index: -5;
}

.container-sing>img {
    width: 100%;
    z-index: -1;
    object-fit: cover;
    position: absolute;
}

.container-sing>* {
    pointer-events: auto;
    flex-shrink: 0;
}

.screen a {
    text-decoration: none;
    display: contents;
}

.buttons>div {
    width: 3.5rem;
    height: 3.5rem;
}

.buttons>div>img {
    width: 100%;
}

.home {
    position: fixed;
    left: 4%;
    top: 7%;
    filter: drop-shadow(0px 4px 2px rgba(0, 0, 0, 0.25));
    z-index: 10;
}

.help {
    position: absolute;
    left: 4%;
    bottom: 7%;
    filter: drop-shadow(0px 4px 2px rgba(0, 0, 0, 0.25));
}

.next {
    position: absolute;
    right: 4%;
    bottom: 7%;
    filter: drop-shadow(0px 4px 2px rgba(0, 0, 0, 0.25));
}

/*
max 480px -> 0.5rem
min 480px - max 550px -> 0.6rem
min 550px - max 630px -> 0.7rem
min 630px - max 718px -> 0.8rem
min 718px - max 806px -> 0.9rem
min 806px - max 1024px -> 1rem
min 1024px - max 1200px -> 1.1rem
min 1200px - max 1366px -> 1.2rem
min 1366px - max 1540px -> 1.3rem
min 1540px - max 1680px -> 1.4rem
min 1680px - max 2350px -> 1.5rem
min 2350px -> 1.6rem
 */

@media only screen and (max-width: 480px) {}

@media only screen and (min-width: 480px) and (max-width: 550px) {}

@media only screen and (min-width: 550px) and (max-width: 630px) {}

@media only screen and (min-width: 630px) and (max-width: 718px) {}

@media only screen and (min-width: 718px) and (max-width: 806px) {}

@media only screen and (min-width: 806px) and (max-width: 1024px) {}

@media only screen and (min-width: 1024px) and (max-width: 1200px) {}

@media only screen and (min-width: 1200px) and (max-width: 1366px) {}

@media only screen and (min-width: 1366px) and (max-width: 1540px) {}

@media only screen and (min-width: 1540px) and (max-width: 1680px) {}

@media only screen and (min-width: 1680px) and (max-width: 2350px) {}

@media only screen and (min-width: 2350px) {}
</style>
